import React from 'react';
import { SectionHeader } from './ui/SectionHeader';
import { benefits } from '../data/content';
export function BenefitsSection() {
  return <section aria-labelledby="beneficios" className="border-b border-arena bg-crudo" data-id="element-17" data-mp="bfj6p4q0ph8">
      <div className="mx-auto max-w-3xl px-4 py-6 sm:py-9" data-id="element-18" data-mp="3ipot5dljxmay">
        <SectionHeader id="beneficios" title="¿Qué puede cambiar cuando empiezas?" description="Una habilidad creativa puede abrir nuevas posibilidades." data-id="element-19" data-mp="3normi0s66433" />
        <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-20" data-mp="3dqvgtoi041cd">
          {benefits.map(b => <li key={b.title} className="flex gap-2.5 rounded-xl border border-arena bg-arena/30 p-3" data-id="element-21" data-mp="2zrlxwh2eut4p">
              <span aria-hidden="true" className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-olive/15 text-base" data-id="element-22" data-mp="34q5k8ikx26xl">
                {b.emoji}
              </span>
              <div data-id="element-23" data-mp="12xr67ulhtmmg">
                <h3 className="text-sm font-extrabold text-marron" data-id="element-24" data-mp="12yaojcf22d10">{b.title}</h3>
                <p className="mt-0.5 text-[0.8rem] leading-snug text-marron/80 sm:text-sm" data-id="element-25" data-mp="2bdut2vqd4mda">{b.desc}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}